export const Waveform = () => {
  return <div>Waveform</div>;
};

Waveform.defaultSize = { width: 10, height: 4 };

Waveform.properties = {};

Waveform.events = {};
